import { useAuth0Context } from "@/context/Auth0Context";
import { useMe } from "@/hooks/user/useMe";
import ProfileCompletionPage from "@/pages/client-trainee/ProfileCompletion";
import LoadingPage from "@/pages/common/LoadingPage";

interface ProfileCompletionGuardProps {
  children: React.ReactNode;
  requiresProfile?: boolean; // Optional - only guard specific routes
}

export const ProfileCompletionGuard: React.FC<ProfileCompletionGuardProps> = ({
  children,
  requiresProfile = false,
}) => {
  const {
    user,
    roles,
    isAuthenticated,
    isLoading: isLoadingAuth,
  } = useAuth0Context();
  const { data: dbUser, isLoading: isLoadingUser } = useMe();

  const isLoading = isLoadingAuth || isLoadingUser;
  if (isLoading) {
    return <LoadingPage />;
  }

  if (
    isAuthenticated
    // (roles.includes("client-trainee") || roles.includes("internal-admin"))
  ) {
    const userTitle = dbUser?.title;
    if (!userTitle) {
      return <ProfileCompletionPage />;
    }
  }

  return <>{children}</>;
};
